import {all, fork} from 'redux-saga/effects';
import accountSaga from './account.saga';
import StaticDataSaga from "./staticData.saga";

// Redux Saga: Root Saga
export default function* rootSaga() {
    yield all([
        fork(accountSaga),
        fork(StaticDataSaga),
    ]);
}
